import Vue from 'vue'
import { router } from '@/router'
import store from '@/store'

import ElementUI from 'element-ui';
import 'element-theme-chalk';
import locale from 'element-ui/lib/locale/lang/en';
import 'element-ui/lib/theme-chalk/reset.css';
import axios from 'axios';

import App from '@/App.vue'

Vue.use(ElementUI, { locale });

Vue.config.productionTip = false

console.log('env', process.env)

axios.interceptors.response.use(function (response) {
  return response;
}, function (error) {
  const status = error.response && error.response.status;
  const url = (error.config && error.config.url) || '';
  // A 401 from the login call itself means wrong credentials — let the login
  // page render that. Only a 401 elsewhere means the session expired, and a
  // hard reload there would otherwise wipe the message before it is seen.
  const isLoginCall = url.indexOf('auth/login') !== -1;
  if (status === 401 && !isLoginCall) {
    localStorage.removeItem('user');
    if (window.location.pathname !== '/login') {
      window.location = '/login';
    }
  }
  return Promise.reject(error);
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

global.toObject = obj => {
  return JSON.parse(JSON.stringify(obj));
};